import React from 'react';
import Header from './Header';
import HeroSection from './HeroSection';
import ServicesFeatures from './ServicesFeatures';
import BookPreviewSection from './BookPreviewSection';
import WorkingProcess from './WorkingProcess';
import TestimonialsSection from './TestimonialsSection';
import PricingSection from './PricingSection';
import WritersCorner from './WritersCorner';
import ContactForm from './ContactForm';
import Footer from './Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-cream-50">
      <Header />

      <main>
        <section id="hero">
          <HeroSection />
        </section>

        <section id="services">
          <ServicesFeatures />
        </section>

        <section id="preview">
          <BookPreviewSection />
        </section>

        <section id="process">
          <WorkingProcess />
        </section>

        <section id="testimonials">
          <TestimonialsSection />
        </section>

        <section id="pricing">
          <PricingSection />
        </section>

        <section id="articles">
          <WritersCorner />
        </section>

        <section id="contact">
          <ContactForm />
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default LandingPage;
